module.exports = __webpack_public_path__ + "img/icon-phone.1b8e73c0.svg";